import PropTypes from 'prop-types';
import { memo } from 'react';

import { useTownAssets } from '../stores';
import { config, logError } from '../utils';

import SvgColorImg from './SvgColorImg';

function CategoryIcon(props) {
  const {
    className = '',
    category = null,
    translateType = 'userMainMenu',
    imgColor,
    imgColorAsCssFill,
    halo = false,
    outline = false,
  } = props;
  const { assets } = useTownAssets();

  if (!assets) return (null);

  if (config.addLaterOn) {
    //
    // TBD: replace with GcatCodeIcon
    //
    //
    return (
      <SvgColorImg
        description={(category)
          ? assets.translate(category, translateType)
          : ''}
        src={(category)
          ? `/images/svg/cases/${category}.svg`
          : '/images/svg/cases/question.svg'}
        defaultCone
        className={(category) ? className : `${className} unkown`}
        imgColor={imgColor}
        missCallback={(src) => {
          logError(
            `Missing category icon ${src}`,
            'CategoryIcon.missingIcon',
            {
              src,
              category,
              translateType,
            },
          );
        }}
        imgColorAsCssFill={imgColorAsCssFill}
        halo={halo}
        outline={outline}
      />
    );
  }

  return false;
}

CategoryIcon.propTypes = {
  className: PropTypes.string,
  category: PropTypes.string,
  translateType: PropTypes.string,
  imgColor: PropTypes.string,
  imgColorAsCssFill: PropTypes.bool,
  halo: PropTypes.bool,
  outline: PropTypes.bool,
};

export default memo(CategoryIcon);
